import { SafeMap } from 'app/tools/utils';

export const StatusType = {
  new: 'New',
  under_diagnosis: 'Under Diagnosis',
  under_repair: 'Under Repair',
  repair_complete: 'Repair Complete',
  ready_for_collection: 'Ready for Collection',
  collected: 'Collected',
  customer_confirmed: 'Customer Confirmed',
  customer_drop_off: 'Customer Drop Off',
  accepted: 'Accepted',
};

export const StatusTypeMap = new SafeMap(StatusType);
